import { techDocWebsocketCommands } from '../../constants/techDocWebsocketCommands';
import { errorAlert } from '../alertsActions';
import alertMessages from '../../intl/common/alertMessages';
import {domains} from '../../constants/Utils';
import {
    validateEscalationSchemaCreateEvent,
    validateEscalationSchemaUpdateEvent
} from '../../api/validation/escalationSchema';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';


export const updateEscalationSchema = (domain, data) => dispatch => {
    const { error } = validateEscalationSchemaUpdateEvent(data);
    if (error) {
        switch (domain) {
            case domains.TECHNICAL_DOCUMENTATION: {
                dispatch(errorAlert(alertMessages.ESCALATION_SCHEMA_UPDATE_SEND_ERROR, [error.toString()]));
                dispatch({type: techDocWebsocketCommands.TECH_DOC_ESCALATION_SCHEMA_SAVE_UPDATE_ERROR});
                break;
            }
            case domains.SPARE_PARTS:
                dispatch(errorAlert(alertMessages.ESCALATION_SCHEMA_UPDATE_SEND_ERROR, [error.toString()]));
                dispatch({type: sparePartsWebsocketCommands.SPARE_PARTS_ESCALATION_SCHEMA_SAVE_UPDATE_ERROR});
                break;

        }
    } else {
        switch (domain) {
            case domains.TECHNICAL_DOCUMENTATION: {
                return dispatch({
                    type: techDocWebsocketCommands.TECH_DOC_ESCALATION_SCHEMA_UPDATE_PENDING,
                    techDocWebsocket: true,
                    command: techDocWebsocketCommands.TECH_DOC_ESCALATION_SCHEMA_UPDATE,
                    payload: {
                        payload: {
                            ...data
                        }
                    }
                });
            }
            case domains.SPARE_PARTS: {
                return dispatch({
                    type: sparePartsWebsocketCommands.SPARE_PARTS_ESCALATION_SCHEMA_UPDATE_PENDING,
                    sparePartsWebsocket: true,
                    command: sparePartsWebsocketCommands.SPARE_PARTS_ESCALATION_SCHEMA_UPDATE,
                    payload: {
                        payload: {
                            ...data
                        }
                    }
                });
            }
        }
    }
};

export const saveEscalationSchema = (domain, data) => dispatch => {
    let shouldContinue = true;
    data.forEach(item => {
        const {error} = validateEscalationSchemaCreateEvent(item);
        if (error && domain === domains.TECHNICAL_DOCUMENTATION) {
            dispatch(errorAlert(alertMessages.ESCALATION_SCHEMA_NEW_SEND_ERROR, [error.toString()]));
            dispatch({type: techDocWebsocketCommands.TECH_DOC_ESCALATION_SCHEMA_SAVE_NEW_ERROR});
            shouldContinue = false;
        }
        if (error && domain === domains.SPARE_PARTS) {
            dispatch(errorAlert(alertMessages.ESCALATION_SCHEMA_NEW_SEND_ERROR, [error.toString()]));
            dispatch({type: sparePartsWebsocketCommands.SPARE_PARTS_ESCALATION_SCHEMA_SAVE_NEW_ERROR});
            shouldContinue = false;
        }
    });
    if (shouldContinue && domain === domains.TECHNICAL_DOCUMENTATION) {
        data.forEach(item => {
            dispatch({
                type: techDocWebsocketCommands.TECH_DOC_ESCALATION_SCHEMA_CREATE_PENDING,
                techDocWebsocket: true,
                command: techDocWebsocketCommands.TECH_DOC_ESCALATION_SCHEMA_CREATE,
                payload: {
                    payload: {
                        ...item,
                    }
                }
            })
        });
    }
    if (shouldContinue && domain === domains.SPARE_PARTS) {
        data.forEach(item => {
            dispatch({
                type: sparePartsWebsocketCommands.SPARE_PARTS_ESCALATION_SCHEMA_CREATE_PENDING,
                sparePartsWebsocket: true,
                command: sparePartsWebsocketCommands.SPARE_PARTS_ESCALATION_SCHEMA_CREATE,
                payload: {
                    payload: {
                        ...item,
                    }
                }
            })
        });
    }

};

export const fetchEscalationSchema = (domain, id) => dispatch => {
    switch (domain) {
        case domains.TECHNICAL_DOCUMENTATION: {
            return dispatch({
                type: techDocWebsocketCommands.TECH_DOC_ESCALATION_SCHEMA_DETAIL_FETCH_PENDING,
                techDocWebsocket: true,
                command: techDocWebsocketCommands.TECH_DOC_ESCALATION_SCHEMA_DETAIL,
                payload: {
                    escalationSchema: {
                        id
                    },
                }
            });
        }
        case domains.SPARE_PARTS: {
            return dispatch({
                type: sparePartsWebsocketCommands.SPARE_PARTS_ESCALATION_SCHEMA_DETAIL_FETCH_PENDING,
                sparePartsWebsocket: true,
                command: sparePartsWebsocketCommands.SPARE_PARTS_ESCALATION_SCHEMA_DETAIL,
                payload: {
                    escalationSchema: {
                        id
                    },
                }
            });
        }
    }
};

export const resetEscalationSchema = domain => dispatch => {
    switch (domain) {
        case domains.TECHNICAL_DOCUMENTATION: {
            return dispatch({
                type: techDocWebsocketCommands.TECH_DOC_ESCALATION_SCHEMA_RESET,
            });
        }
        case domains.SPARE_PARTS: {
            return dispatch({
                type: sparePartsWebsocketCommands.SPARE_PARTS_ESCALATION_SCHEMA_RESET,
            });
        }
    }
};

export const redirectReset = domain => dispatch => {
    switch (domain) {
        case domains.TECHNICAL_DOCUMENTATION: {
            return dispatch({
                type: techDocWebsocketCommands.TECH_DOC_ESCALATION_SCHEMA_REDIRECT_RESET,
            });
        }
        case domains.SPARE_PARTS: {
            return dispatch({
                type: sparePartsWebsocketCommands.SPARE_PARTS_ESCALATION_SCHEMA_REDIRECT_RESET,
            });
        }
    }
};
